<template>
  <div id="indexContainer" ref="scrollBox">
    <div class="main">
      <div>
        <div id="indexContainer">
          <div>
            <div style="display: flex;flex-direction: column;align-items: center;">
              <div style="box-sizing: border-box;text-align: center;color: #000; display: flex; align-items: center;justify-content: center;">
                <div style="display: block; unicode-bidi: isolate;">
                  <h3 class="bounceInLeft animated">实验室及仪器</h3>
                  <p class="bounceInRight animated">实验室检测用设备和仪器装置等</p>
                  <p class="bounceInRight animated"></p>
                </div>
              </div>
              <div style="max-width: 1170px;display: flex;flex-wrap: wrap;justify-content: center; padding: 10px 5px; box-sizing: border-box;">
                <div style="display: flex; flex-direction: column; align-items: center; padding: 0 6px 12px 6px;">
                  <div style="display: flex; justify-content: center; align-items: center; border: 1px dashed #e4e7ed; box-sizing: border-box;width: 300px; height: 242px;overflow: hidden;">
                    <img style="transition: all .5s; width: 70%;" src="@/assets/images/images/2.jpg" alt=""></div>
                    <p style="margin: 0; padding: 5px 0;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;font-size: 15px; font-weight: 700;background-color: #fff; text-align: center;width: 300px;">实验装置1</p>
                </div>
                <div style="display: flex; flex-direction: column; align-items: center; padding: 0 6px 12px 6px;">
                  <div style="display: flex; justify-content: center; align-items: center; border: 1px dashed #e4e7ed; box-sizing: border-box;width: 300px; height: 242px;overflow: hidden;">
                    <img style="transition: all .5s; width: 70%;" src="@/assets/images/images/3.jpg" alt=""></div>
                    <p style="margin: 0; padding: 5px 0;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;font-size: 15px; font-weight: 700;background-color: #fff; text-align: center;width: 300px;">实验装置2</p>
                </div>
                <div style="display: flex; flex-direction: column; align-items: center; padding: 0 6px 12px 6px;">
                  <div style="display: flex; justify-content: center; align-items: center; border: 1px dashed #e4e7ed; box-sizing: border-box;width: 300px; height: 242px;overflow: hidden;">
                    <img style="transition: all .5s; width: 70%;" src="@/assets/images/images/4.jpg" alt=""></div>
                    <p style="margin: 0; padding: 5px 0;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;font-size: 15px; font-weight: 700;background-color: #fff; text-align: center;width: 300px;">实验装置3</p>
                </div>
                <div style="display: flex; flex-direction: column; align-items: center; padding: 0 6px 12px 6px;">
                  <div style="display: flex; justify-content: center; align-items: center; border: 1px dashed #e4e7ed; box-sizing: border-box;width: 300px; height: 242px;overflow: hidden;">
                    <img style="transition: all .5s; width: 70%;" src="@/assets/images/images/5.jpg" alt=""></div>
                    <p style="margin: 0; padding: 5px 0;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;font-size: 15px; font-weight: 700;background-color: #fff; text-align: center;width: 300px;">实验装置4</p>
                </div>
                <div style="display: flex; flex-direction: column; align-items: center; padding: 0 6px 12px 6px;">
                  <div style="display: flex; justify-content: center; align-items: center; border: 1px dashed #e4e7ed; box-sizing: border-box;width: 300px; height: 242px;overflow: hidden;">
                    <img style="transition: all .5s; width: 70%;" src="@/assets/images/images/6.jpg" alt=""></div>
                    <p style="margin: 0; padding: 5px 0;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;font-size: 15px; font-weight: 700;background-color: #fff; text-align: center;width: 300px;">实验装置5</p>
                </div>
              </div>
              <button type="button" class="el-button animated fadeInUpBig el-button--primary is-round">
                <span>更多<i class="el-icon-right el-icon--right"></i></span>
              </button>
            </div>
          </div>
          <div style="animation-duration: 1s; animation-fill-mode: both;display: block; unicode-bidi: isolate;">
            <div class="qy">
              <div style="color: rgb(255, 255, 255);box-sizing: border-box;text-align: center;color: #000; display: flex;align-items: center;justify-content: center;">
                <div style=" display: block;unicode-bidi: isolate;">
                  <h3 style="transform: translateX(0px);opacity: 1;margin-top: 0;font-size: 22px; margin-bottom: 8px;">企业文化</h3>
                  <p style="transform: translateX(0px);opacity: 1;margin-bottom: 0; margin-top: 5px; color: #bcbcbc;font-size: 14px;">我们提供的就是您想要的服务</p>
                  <p style="transform: translateX(0px);opacity: 1;margin-bottom: 0; margin-top: 5px; color: #bcbcbc;font-size: 14px;"></p>
                </div>
              </div>
              <div style="margin: 0 auto;  width: 1200px;">
                <ul style="margin: 0;min-height: 400px; padding: 10px 0;display: flex;flex-wrap: wrap;justify-content: space-between;">
                  <li style="transform: translateY(0px); opacity: 1;list-style: none;margin: 5px;">
                    <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;  color: #fff; width: 212px;
                      padding: 56px 24px;box-sizing: border-box; transition: .5s; border: 1px solid #6d6b68;border-radius: 4px; background: hsla(0, 0%, 100%, .05);">
                      <svg style="width: 1em; height: 1em;vertical-align: -.15em; fill: currentColor; overflow: hidden;" aria-hidden="true" class="svg-icon" font-size="48px">
                        <use xlink:href="#icon-tuandui"></use>
                      </svg>
                      <p style="font-size: 30px;display: block;margin-block-start: 1em;margin-block-end: 1em;margin-inline-start: 0px;margin-inline-end: 0px; unicode-bidi: isolate;">企业使命</p>
                      <p style="margin-block-start: 1em;margin-block-end: 1em;margin-inline-start: 0px;margin-inline-end: 0px; unicode-bidi: isolate;width: 100%; height: 60px;text-align: center;  line-height: 30px;overflow: hidden; text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">一切以用户价值为依归</p>
                    </div>
                  </li>
                  <li style="transform: translateY(0px); opacity: 1;list-style: none;margin: 5px;">
                    <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;  color: #fff; width: 212px;
                      padding: 56px 24px;box-sizing: border-box; transition: .5s; border: 1px solid #6d6b68;border-radius: 4px; background: hsla(0, 0%, 100%, .05);">
                      <svg style="width: 1em; height: 1em;vertical-align: -.15em; fill: currentColor; overflow: hidden;" aria-hidden="true" class="svg-icon" font-size="48px">
                        <use  xlink:href="#icon-lingyu"></use>
                      </svg>
                      <p style="font-size: 30px;display: block;margin-block-start: 1em;margin-block-end: 1em;margin-inline-start: 0px;margin-inline-end: 0px; unicode-bidi: isolate;">企业精神</p>
                      <p style="margin-block-start: 1em;margin-block-end: 1em;margin-inline-start: 0px;margin-inline-end: 0px; unicode-bidi: isolate;width: 100%; height: 60px;text-align: center;  line-height: 30px;overflow: hidden; text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">心有阳光，安能温暖</p>
                    </div>
                  </li>
                  <li style="transform: translateY(0px); opacity: 1;list-style: none;margin: 5px;">
                    <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;  color: #fff; width: 212px;
                      padding: 56px 24px;box-sizing: border-box; transition: .5s; border: 1px solid #6d6b68;border-radius: 4px; background: hsla(0, 0%, 100%, .05);">
                      <svg style="width: 1em; height: 1em;vertical-align: -.15em; fill: currentColor; overflow: hidden;" aria-hidden="true" class="svg-icon" font-size="48px">   
                        <use xlink:href="#icon-gaozhi"></use>
                      </svg>
                      <p style="font-size: 30px;display: block;margin-block-start: 1em;margin-block-end: 1em;margin-inline-start: 0px;margin-inline-end: 0px; unicode-bidi: isolate;">服务理念</p>
                      <p style="margin-block-start: 1em;margin-block-end: 1em;margin-inline-start: 0px;margin-inline-end: 0px; unicode-bidi: isolate;width: 100%; height: 60px;text-align: center;  line-height: 30px;overflow: hidden; text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">诚信第一、质量第一、科学公正、优质服务</p>
                    </div>
                  </li>
                  <li style="transform: translateY(0px); opacity: 1;list-style: none;margin: 5px;">
                    <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;  color: #fff; width: 212px;
                      padding: 56px 24px;box-sizing: border-box; transition: .5s; border: 1px solid #6d6b68;border-radius: 4px; background: hsla(0, 0%, 100%, .05);">
                      <svg style="width: 1em; height: 1em;vertical-align: -.15em; fill: currentColor; overflow: hidden;" aria-hidden="true" class="svg-icon" font-size="48px">
                        <use  xlink:href="#icon-yunying"></use>
                      </svg>
                      <p style="font-size: 30px;display: block;margin-block-start: 1em;margin-block-end: 1em;margin-inline-start: 0px;margin-inline-end: 0px; unicode-bidi: isolate;">企业远景</p>
                      <p style="margin-block-start: 1em;margin-block-end: 1em;margin-inline-start: 0px;margin-inline-end: 0px; unicode-bidi: isolate;width: 100%; height: 60px;text-align: center;  line-height: 30px;overflow: hidden; text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">成为全国受尊敬的检测机构</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <div style="display: flex;flex-direction: column;align-items: center;">
              <div style="box-sizing: border-box;text-align: center; color: #000; display: flex; align-items: center; justify-content: center;height: 200px;">
                <div style="display: block; unicode-bidi: isolate;">
                  <h3 style="margin-top: 0; font-size: 22px;margin-bottom: 8px;">服务承诺</h3>
                  <p style="margin-bottom: 0; margin-top: 5px; color: #bcbcbc; font-size: 14px;"></p>
                  <p style="margin-bottom: 0; margin-top: 5px; color: #bcbcbc; font-size: 14px;"></p>
                </div>
              </div>
              <div style="width: 100%; display: flex;justify-content: center;max-width: 1200px;">
                <div style="width: 40%;"><img style="    transition: all .5s;width: 100%;border-style: none;overflow-clip-margin: content-box; overflow: clip;" src="@/assets/images/images/1.jpg" alt=""></div>
                <div style="flex: 1;  padding-left: 80px; line-height: 32px;">
                  <p style="text-indent: 2em;display: block; margin-block-start: 1em; margin-block-end: 1em;margin-inline-start: 0px; margin-inline-end: 0px; unicode-bidi: isolate;"> 公司依据AQ/T 8006-2018《安全生产检测检验能力的通用要求》、AQ/T
                    8012-2022《安全生产检测检验机构诚信建设规范》要求，按照资质认定和实验室认可等规范，结合公司实际情况，建立并不断完善管理体系确保持续有效运行，达到法定检测检验机构要求，更好地为企业的安全生产服务。
                  </p>
                  <p style="text-indent: 2em;display: block; margin-block-start: 1em; margin-block-end: 1em;margin-inline-start: 0px; margin-inline-end: 0px; unicode-bidi: isolate;">
                    我们把安全检测质量、速度等服务放在第一位，坚守安全底线，切实推行全面质量管理，坚持“诚信第一、质量第一、科学公正、优质服务”的服务准则。严格执行相关检测检验标准规范，保守客户的商业机密，恪守公正、严谨、精准、高效的质量方针,以科学、严谨的态度坚守职业道德，发挥检测检验机构应有的作用，为矿山安全生产工作做出积极的贡献。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div><!---->
      </div>
    </div>


  </div>
</template>

<script>
import productList from '@/components/index/productList'
import solutionList from '@/components/index/solutionList'
import projectList from '@/components/index/projectList'
import download from '@/components/index/downloadCenter'
import company from '@/components/index/Company'
import advantage from '@/components/index/Advantage'
import partnerAcademy from '@/components/index/PartnerAcademy'
import learnPlatform from '@/components/index/LearnPlatform'
import trainShow from '@/components/index/TrainShow'
import newsList from '@/components/index/NewsList'
import serviceProcess from '@/components/index/serviceProcess'
export default {
  name: 'indexContainer',
  components: { serviceProcess, download, productList, solutionList, projectList, company, advantage, trainShow, newsList, partnerAcademy, learnPlatform },
  data() {
    return {
    }
  },
  methods: {
  },
  mounted() {
    this.$nextTick(function () {
      this.$store.state.el_.scrollTop = 0
    })
  }
}
</script>
<style src="../../common/styles/app.css"></style>
<style lang='less' scoped>
#indexContainer {
  position: relative;
  height: 100%;
}

.animateHide {
  opacity: 0;
}
@keyframes bounceInLeft {
    0% {
        opacity: 0;
        transform: translateX(-2000px)
    }

    60% {
        opacity: 1;
        transform: translateX(30px)
    }

    80% {
        transform: translateX(-10px)
    }

    to {
        transform: translateX(0)
    }
}

.bounceInLeft {
    animation-name: bounceInLeft
}

@keyframes bounceInRight {
    0% {
        opacity: 0;
        transform: translateX(2000px)
    }

    60% {
        opacity: 1;
        transform: translateX(-30px)
    }

    80% {
        transform: translateX(10px)
    }

    to {
        transform: translateX(0)
    }
}

.bounceInRight {
    animation-name: bounceInRight
}
.animated {
    animation-duration: 1s;
    animation-fill-mode: both
}
.qy {
    margin-top: 20px;
    background: url("../../assets/images/bg-adv.png") 100% 100%;
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
